module.exports = __webpack_public_path__ + "media/images/slide01-30d890f7ef779cff9a52d7b9e7c33593.jpg";